export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Why Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            See how the Kakobuy Spreadsheet compares to traditional product searching
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse min-w-[600px]">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-900">Feature</th>
                <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-700">Normal Search</th>
                <th className="text-left py-4 px-4 text-sm font-semibold text-primary-600 bg-primary-50/50 rounded-t-lg">Kakobuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200">
                <td className="py-4 px-4 text-sm font-medium text-foreground-800">Product Discovery</td>
                <td className="py-4 px-4 text-sm text-foreground-500">Slow, manual browsing</td>
                <td className="py-4 px-4 text-sm text-foreground-800 font-medium bg-primary-50/30">
                  <span className="w-4 h-4 inline-flex items-center justify-center text-accent-500 mr-1.5">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  Fast, organized categories
                </td>
              </tr>
              <tr className="border-b border-background-200">
                <td className="py-4 px-4 text-sm font-medium text-foreground-800">Product Filtering</td>
                <td className="py-4 px-4 text-sm text-foreground-500">Limited and scattered</td>
                <td className="py-4 px-4 text-sm text-foreground-800 font-medium bg-primary-50/30">
                  <span className="w-4 h-4 inline-flex items-center justify-center text-accent-500 mr-1.5">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  Fully organized by category
                </td>
              </tr>
              <tr className="border-b border-background-200">
                <td className="py-4 px-4 text-sm font-medium text-foreground-800">Trending Items</td>
                <td className="py-4 px-4 text-sm text-foreground-500">Difficult to identify</td>
                <td className="py-4 px-4 text-sm text-foreground-800 font-medium bg-primary-50/30">
                  <span className="w-4 h-4 inline-flex items-center justify-center text-accent-500 mr-1.5">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  Easy to spot trending finds
                </td>
              </tr>
              <tr className="border-b border-background-200">
                <td className="py-4 px-4 text-sm font-medium text-foreground-800">Community Data</td>
                <td className="py-4 px-4 text-sm text-foreground-500">No community feedback</td>
                <td className="py-4 px-4 text-sm text-foreground-800 font-medium bg-primary-50/30">
                  <span className="w-4 h-4 inline-flex items-center justify-center text-accent-500 mr-1.5">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  Real user recommendations
                </td>
              </tr>
              <tr>
                <td className="py-4 px-4 text-sm font-medium text-foreground-800">Update Frequency</td>
                <td className="py-4 px-4 text-sm text-foreground-500">Rarely refreshed</td>
                <td className="py-4 px-4 text-sm text-foreground-800 font-medium bg-primary-50/30 rounded-b-lg">
                  <span className="w-4 h-4 inline-flex items-center justify-center text-accent-500 mr-1.5">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  Regularly updated
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}